// extracted by mini-css-extract-plugin
export var addToCartButton = "_ju-b";
export var arrowButtonContainer = "_ju-9";
export var arrowButtonIcon = "_ju-a";
export var carouselArrowButton = "_ju-6";
export var carouselElementContainer = "_ju-1";
export var left = "_ju-7";
export var productDisplayCarouselContainer = "_ju-0";
export var productTileContainer = "_ju-2";
export var productTileImage = "_ju-4";
export var productTileImageContainer = "_ju-3";
export var productTileTitle = "_ju-5";
export var right = "_ju-8";
export var sliderOverflow = "_ju-c";